module.exports = __webpack_public_path__ + "static/media/loading.29866284.gif";